import styled from 'styled-components/macro';
import { COLORS } from 'styleguide';
import { rgba } from 'polished';

const FilterWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  flex-basis: 95px;
  padding: 20px 0 4px;
  margin: 0 32px 0 24px;
  max-height: 65px;
  background-color: ${COLORS.background};
  border-bottom: 1px solid ${COLORS.line};
  box-shadow: 0 4px 16px 0 ${rgba(COLORS.background, 0.6)};
`;

export default FilterWrapper;
